import { render, staticRenderFns } from "./UpdateEmergencyContact.vue?vue&type=template&id=7179b86a"
import script from "./UpdateEmergencyContact.vue?vue&type=script&lang=js"
export * from "./UpdateEmergencyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports